import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA. Appears once the hero CTA has scrolled out of view
 * (the element with id="hero-cta") and shakes to draw attention.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-950/95 px-4 pb-4 pt-3 backdrop-blur transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-34" data-mp="2aus26g9ln9vi">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-2 sm:flex-row sm:justify-between" data-id="element-35" data-mp="2z2h9ubzn7dv0">
        <p className="hidden text-sm font-semibold text-slate-200 sm:block" data-id="element-36" data-mp="332rffnjiw29c">
          Complete Clinical Route —{' '}
          <span className="text-gold-500" data-id="element-37" data-mp="2pabk78wv58iz">$27 USD</span>, one-time payment
        </p>
        <a href={CHECKOUT_URL} className="flex w-full animate-shake items-center justify-center gap-2 rounded-xl bg-brand-500 px-5 py-4 font-display text-sm font-extrabold uppercase tracking-tight text-white shadow-[0_10px_30px_-10px_rgba(47,123,255,0.8)] transition-colors duration-150 ease-out hover:bg-brand-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 sm:w-auto" data-id="element-38" data-mp="2u94pwf5wrv8l">
          Get instant access — $27
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="4juajnadzt12" />
        </a>
        <p className="text-[0.68rem] font-medium uppercase tracking-[0.12em] text-slate-400 sm:hidden" data-id="element-40" data-mp="9ki1k8ym89va">
          One-time payment · 7-day guarantee
        </p>
      </div>
    </div>;
}